import { Component, Inject, OnInit } from '@angular/core';
import { MatSnackBarRef, MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';

@Component({
  selector: 'app-custom-snackbar',
  templateUrl: './custom-snackbar.component.html',
  styleUrls: ['./custom-snackbar.component.css']
})
export class CustomSnackbarComponent implements OnInit {

  constructor(public snackBarRef: MatSnackBarRef<CustomSnackbarComponent>,@Inject(MAT_SNACK_BAR_DATA) public data: { type: string; message: string,action: string,duration: number }) {}

  ngOnInit(): void {
    if (this.data.duration) {
      setTimeout(() => {
        this.snackBarRef.dismiss();
      }, this.data.duration);
    }
  }

}
